
import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';

import { IonicVue } from '@ionic/vue';
import createStore from '@/store';
import reactiveToday from '@/reactiveToday';
import { tlDirective, tlMixin } from '@/localization';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import './theme/global.css';

/* Theme variables */
import './theme/variables.css';

import { Capacitor } from '@capacitor/core';

if (Capacitor.getPlatform() === 'web')
    await import('./registerServiceWorker');


(async function () {
    const store = await createStore();
    const app = createApp(App)
        .use(IonicVue)
        .use(router)
        .use(store)
        .mixin(reactiveToday)
        .mixin(tlMixin)
        .directive('tl', tlDirective)
    ;

    await router.isReady();
    app.mount('#app');
}());